/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserConditionDto } from "./UserConditionDto";
export type MatchUserConditionsRequestDto = {
  combinator: MatchUserConditionsRequestDto.combinator;
  conditions: Array<UserConditionDto>;
};
export namespace MatchUserConditionsRequestDto {
  export enum combinator {
    AND = "AND",
    OR = "OR",
  }
}
